/*
 * whatsapp-only.js — Modo "Solo WhatsApp" para ROA LIVE.
 *
 * Cuando el tema tiene activado settings.booking_whatsapp_only, este script:
 *   - Intercepta TODOS los botones de reserva (.booking-product-form__submit) y el
 *     botón de pago del carrito ([name="checkout"]) en fase de captura, ANTES de que
 *     corra el JavaScript que normalmente agrega al carrito / va al checkout.
 *   - En su lugar, arma un mensaje de WhatsApp con los datos que el cliente ya llenó
 *     (servicio + campos del formulario) y abre wa.me con el mensaje pre-cargado.
 *   - Reetiqueta los botones a "Reservar por WhatsApp".
 *
 * Es 100% reversible: se desactiva apagando el check del tema (o quitando el include
 * en theme.liquid). No modifica los formularios ni el resto del JS de reservas.
 */
(function () {
  var cfg = window.ROALIVE_WA_ONLY || {};
  var WA = String(cfg.number || '').replace(/[^0-9]/g, '');
  if (!WA) return;

  // Idioma del mensaje = idioma de la página (auto). 'es' → español; 'fr' → francés; cualquier otro → inglés.
  var rawLocale = (cfg.locale || document.documentElement.lang || 'en');
  var ES = String(rawLocale).toLowerCase().indexOf('es') === 0;
  var FR = String(rawLocale).toLowerCase().indexOf('fr') === 0;

  // Marca de origen: todo WhatsApp que sale de roatanlive.com termina con "· ROA"
  // para que el equipo sepa que vino de este sitio (Blue Bay usa el mismo número).
  var TAG = '\n· ROA';
  function withTag(text) {
    text = String(text || '');
    return text.indexOf('· ROA') === -1 ? text + TAG : text;
  }
  // Agrega la marca a cualquier enlace de WhatsApp con mensaje (botones, formularios
  // de los artículos) justo antes de que se abra. Sin mensaje → no se toca.
  function tagLink(a) {
    var h = a.getAttribute('href') || '';
    if (!/wa\.me\/|api\.whatsapp\.com|whatsapp:\/\//i.test(h)) return;
    var nuevo = h.replace(/([?&]text=)([^&#]*)/i, function (m, k, v) {
      var plano;
      try { plano = decodeURIComponent(v.replace(/\+/g, ' ')); } catch (err) { plano = v; }
      return plano.indexOf('· ROA') === -1 ? k + v + encodeURIComponent(TAG) : m;
    });
    if (nuevo !== h) a.setAttribute('href', nuevo);
  }
  function onLinkCapture(e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (a) tagLink(a);
  }
  document.addEventListener('click', onLinkCapture, true);
  document.addEventListener('auxclick', onLinkCapture, true);

  var T = ES ? {
    button: 'Reservar por WhatsApp',
    greeting: '¡Hola! Quiero reservar',
    details: 'Datos de mi reserva:',
    generic: '¡Hola! Quiero hacer una reserva.'
  } : FR ? {
    button: 'Réserver sur WhatsApp',
    greeting: "Bonjour ! J'aimerais réserver",
    details: 'Détails de ma réservation :',
    generic: "Bonjour ! J'aimerais faire une réservation.",
    sep: ' : '
  } : {
    button: 'Book via WhatsApp',
    greeting: "Hi! I'd like to book",
    details: 'My booking details:',
    generic: "Hi! I'd like to make a booking."
  };

  // Traducción de las etiquetas internas (inglés) a español para el mensaje.
  var LABELS = {
    'Full name': 'Nombre',
    'WhatsApp': 'WhatsApp',
    'WhatsApp number': 'WhatsApp',
    'Number of guests': 'N° de personas',
    'Group size (passengers)': 'N° de personas',
    'Passengers paying for': 'N° de personas',
    'Tour date': 'Fecha del tour',
    'Tour time': 'Hora del tour',
    'Transfer date': 'Fecha del transfer',
    'Pickup time': 'Hora de pickup',
    'Pickup location': 'Lugar de pickup',
    'Pick-up location': 'Lugar de pickup',
    'Flight number': 'N° de vuelo',
    'Hotel': 'Hotel',
    'Number of suitcases': 'Maletas',
    'Ferry company': 'Ferry',
    'Comments': 'Comentarios',
    'Special requests': 'Solicitudes especiales',
    'Return date': 'Fecha de regreso',
    'Return pickup time': 'Hora de regreso',
    'Return flight number': 'N° de vuelo (regreso)',
    'Adults': 'Adultos',
    'Minors': 'Menores',
    'Minor ages': 'Edades de los menores',
    'Needs transport': 'Necesita transporte',
    'Pickup zone': 'Zona de recogida',
    'Number of passengers': 'N° de pasajeros',
    'Children 6 & under (half price)': 'Niños de 6 o menos (mitad de precio)'
  };
  // Lo mismo en francés.
  var LABELS_FR = {
    'Full name': 'Nom',
    'WhatsApp': 'WhatsApp',
    'WhatsApp number': 'WhatsApp',
    'Number of guests': 'Nombre de personnes',
    'Group size (passengers)': 'Nombre de personnes',
    'Passengers paying for': 'Nombre de personnes',
    'Tour date': "Date de l'excursion",
    'Tour time': "Heure de l'excursion",
    'Transfer date': 'Date du transfert',
    'Pickup time': 'Heure de prise en charge',
    'Pickup location': 'Lieu de prise en charge',
    'Pick-up location': 'Lieu de prise en charge',
    'Flight number': 'N° de vol',
    'Hotel': 'Hôtel',
    'Number of suitcases': 'Valises',
    'Ferry company': 'Ferry',
    'Comments': 'Commentaires',
    'Special requests': 'Demandes particulières',
    'Return date': 'Date de retour',
    'Return pickup time': 'Heure de prise en charge (retour)',
    'Return flight number': 'N° de vol (retour)',
    'Adults': 'Adultes',
    'Minors': 'Mineurs',
    'Minor ages': 'Âge des mineurs',
    'Needs transport': 'Besoin de transport',
    'Pickup zone': 'Zone de prise en charge',
    'Number of passengers': 'Nombre de passagers',
    'Children 6 & under (half price)': 'Enfants de 6 ans et moins (demi-tarif)'
  };

  function serviceName() {
    var h1 = document.querySelector('main h1, h1');
    var name = h1 && h1.textContent ? h1.textContent.trim() : '';
    if (!name) name = (document.title || '').split('–')[0].split('|')[0].trim();
    return name.replace(/\s+/g, ' ');
  }

  function labelFor(el) {
    var n = el.getAttribute('name') || '';
    var m = n.match(/properties\[(.+)\]/);
    var raw = m ? m[1] : '';
    if (raw) return (ES && LABELS[raw]) ? LABELS[raw] : (FR && LABELS_FR[raw]) ? LABELS_FR[raw] : raw;
    if (el.id) {
      var lab = document.querySelector('label[for="' + el.id + '"]');
      if (lab) return lab.textContent.trim().replace(/\s+/g, ' ');
    }
    return '';
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function gather(form) {
    var lines = [];
    var seen = {};
    var els = form.querySelectorAll(
      'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'
    );
    Array.prototype.forEach.call(els, function (el) {
      if (el.type === 'hidden' || el.disabled) return;
      if (!isVisible(el)) return; // salta campos en secciones colapsadas (ej. regreso)
      var label = labelFor(el);
      var value = (el.value || '').trim();
      if (el.type === 'checkbox') value = el.checked ? (FR ? 'Oui' : 'Sí') : '';
      if (!label || !value) return;
      var key = label.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      lines.push('• ' + label + ': ' + value);
    });
    return lines;
  }

  function buildMessage(form) {
    var svc = serviceName();
    var lines = form ? gather(form) : [];
    var msg = T.greeting;
    if (svc) msg += (T.sep || ': ') + svc;
    msg += '.';
    if (lines.length) msg += '\n\n' + T.details + '\n' + lines.join('\n');
    return msg;
  }

  function openWhatsApp(text) {
    var url = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(withTag(text));
    var win = window.open(url, '_blank');
    if (!win) window.location.href = url; // fallback si el navegador bloquea el popup
  }

  function relabel() {
    var btns = document.querySelectorAll(
      '.booking-product-form__submit, [name="checkout"], .main-cart__checkout'
    );
    Array.prototype.forEach.call(btns, function (b) {
      if (b.getAttribute('data-wa-relabeled')) return;
      b.setAttribute('data-wa-relabeled', '1');
      b.textContent = T.button;
    });
  }

  function onClickCapture(e) {
    var btn = e.target.closest &&
      e.target.closest('.booking-product-form__submit, [name="checkout"], .main-cart__checkout');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = btn.closest('form.booking-product-form') || btn.closest('form');
    var hasProps = form && form.querySelector('[name^="properties["]');
    openWhatsApp(hasProps ? buildMessage(form) : T.generic);
  }

  document.addEventListener('click', onClickCapture, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relabel);
  } else {
    relabel();
  }
  // Reetiqueta de nuevo por si algún formulario se renderiza tarde.
  setTimeout(relabel, 800);
  setTimeout(relabel, 2500);
})();
